export const SET_COLLECTION_ITEM_EVENTS = 'Editor/ContextMenu/SET_CONTEXT_MENU';
